import * as R from 'ramda';

const sort = R.sort((a, b) => a - b);

const compareArrays = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;

    const a1 = sort(arr1);
    const a2 = sort(arr2);

    for (let i = 0; i < a1.length; i++) {
        if (a1[i] !== a2[i]) return false;
    }

    return true;
};

const compPathList = (paths, obj1, obj2) => {
    for (let path of paths) {
        const val1 = R.path(path, obj1);
        const val2 = R.path(path, obj2);

        const isSame = Array.isArray(val1)
            ? compareArrays(val1, val2)
            : val1 === val2;

        if (!isSame) return false;
    }
    return true;
};

const FILTER_PATHS = [
    ['startDate'],
    ['endDate'],
    ['rightsholders'],
    ['sponsors'],
    ['placements'],
    ['accOwnTypes'],
    ['mediaTypes'],
    ['platformPostTypePairs'],
    ['accountUsernames'],
    ['authorshipTypes'],
    ['collaboratingAccountUsernames'],
    ['hashtags'],
    ['collections'],
    ['countries'],
    ['broadcastNetworks'],
];

const compareFilters = (oldFilter, newFilter) => {
    const didChange = !compPathList(FILTER_PATHS, oldFilter, newFilter);

    return didChange;
};

export default compareFilters;
